import { getIndicatorPriorSupport } from "../../../../../../rest/indicator";
import { makeWorkbook } from "../../utils/excel";

const rowsFrom = (payload) =>
  Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.results)
    ? payload.results
    : Array.isArray(payload)
    ? payload
    : [];

export async function buildWorkbookPreviousSupport() {
  const resp = await getIndicatorPriorSupport();
  const payload = resp?.data || {};
  const rows = rowsFrom(payload).map((r) => ({
    description: r?.description ?? r?.name ?? "-",
    counter: Number(r?.counter ?? 0), // contratos
    paymentCount: Number(r?.paymentCount ?? 0),
    value: Number(r?.value ?? 0),
  }));

  rows.sort((a, b) => {
    const av = Number(a.value || 0);
    const bv = Number(b.value || 0);
    if (av === bv) {
      return String(a.description || "").localeCompare(
        String(b.description || ""),
        "pt-PT"
      );
    }
    return bv - av;
  });

  const totals = rows.reduce(
    (acc, r) => {
      acc.counter += Number(r.counter || 0);
      acc.paymentCount += Number(r.paymentCount || 0);
      acc.value += Number(r.value || 0);
      return acc;
    },
    { counter: 0, paymentCount: 0, value: 0 }
  );

  const round2 = (n) =>
    Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;

  const avgContrato =
    totals.counter > 0 ? round2(totals.value / totals.counter) : 0;
  const avgPagamento =
    totals.paymentCount > 0 ? round2(totals.value / totals.paymentCount) : 0;

  const detalhe = [
    ["Entidade de Apoio Prévio", "Contratos", "Pagamentos", "Valor"],
    ...rows.map((r) => [
      r.description ?? "-",
      Number(r.counter || 0),
      Number(r.paymentCount || 0),
      Number(r.value || 0),
    ]),
  ];

  const resumo = [
    ["Indicador", "Valor"],
    ["N.º de Entidades", rows.length],
    ["Total Contratos", totals.counter],
    ["Total Pagamentos", totals.paymentCount],
    ["Total Valor", totals.value],
    ["Valor Médio por Contrato", avgContrato],
    ["Valor Médio por Pagamento", avgPagamento],
  ];

  return makeWorkbook([
    { name: "Resumo", aoa: resumo },
    { name: "Detalhe", aoa: detalhe },
  ]);
}
